import { useNavigate } from 'react-router-dom';
import { AlertCircle, RefreshCw, Home } from 'lucide-react';
import { Button } from './ui/button';

const ErrorState = ({ 
  title = 'Failed to load data',
  message = 'Something went wrong while loading this page.',
  onRetry = null,
  showDashboardLink = true 
}) => {
  const navigate = useNavigate();

  return (
    <div 
      className="min-h-[60vh] flex items-center justify-center"
      data-testid="error-state"
    >
      <div className="text-center p-8 max-w-md">
        <div className="bg-red-100 p-4 rounded-full w-20 h-20 mx-auto mb-6 flex items-center justify-center">
          <AlertCircle className="w-10 h-10 text-red-600" />
        </div>
        
        <h2 className="text-2xl font-bold text-slate-900 mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
          {title}
        </h2>
        
        <p className="text-slate-500 mb-6">
          {message}
        </p>
        
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          {onRetry && (
            <Button onClick={onRetry} variant="default" className="gap-2">
              <RefreshCw className="w-4 h-4" />
              Try Again
            </Button>
          )}
          
          {showDashboardLink && (
            <Button 
              onClick={() => navigate('/dashboard')} 
              variant={onRetry ? 'outline' : 'default'}
              className="gap-2"
            >
              <Home className="w-4 h-4" />
              Go to Dashboard
            </Button>
          )}
        </div>
        
        <p className="text-xs text-slate-400 mt-6">
          If this problem persists, please contact support.
        </p>
      </div>
    </div>
  );
};

export default ErrorState;
